<template>
    <div class="components-container">
        <el-row>
            <div class="titles"><span class="fonts">毕业要求</span></div>
        </el-row>
        <el-form class="small-space" :model="createdForm" ref="createdForm" label-position="right" label-width="200px" width="100%" :inline="true">
            <el-form-item v-for="index in courseAttr.length" :key="index" class="form-item-font":label="courseAttr[index-1].comboName + '学分'" :prop="'credit'+index">
                <el-input-number v-model="createdForm['credit'+index]" :disabled="editDisableState" :style="{width:inputWidth+'px'}"
                    :min="0" :precision="3" :step="0.5" :label="'请输入' + courseAttr[index-1].comboName + '学分'">
                </el-input-number>
            </el-form-item>
            <el-form-item label="总学分" class="form-item-font" prop="totalCredit">
                <el-input-number v-model="createdForm.totalCredit" :disabled="editDisableState" :style="{width:inputWidth+'px'}" :min="0" :precision="3" :step="0.5" placeholder="请输入总学分要求">
                </el-input-number>
            </el-form-item>
            <el-form-item label="其他要求" class="form-item-font">
                <el-input v-model="createdForm.otherRequire" :disabled="editDisableState" :style="{width:textareaWidth+'px'}" type="textarea"
                    :autosize="{ minRows: 5, maxRows: 5 }" maxlength="500" show-word-limit></el-input>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    export default {
        props: ["editDisableState", "courseAttr"],
        data() {
            return {
                labelPosition: "right",
                createdForm: {
                    id: null,
                    credit1: 0,
                    credit2: 0,
                    credit3: 0,
                    credit4: 0,
                    credit5: 0,
                    credit6: 0,
                    credit7: 0,
                    credit8: 0,
                    credit9: 0,
                    credit10: 0,
                    credit11: 0,
                    credit12: 0,
                    credit13: 0,
                    credit14: 0,
                    credit15: 0,
                    totalCredit: 0,
                    otherRequire: '',
                },
                inputWidth: 500,
                textareaWidth: 1000,
            };
        },
        mounted() {
            this.$nextTick().then(() => {
                this.inputWidth = window.innerWidth / 2 - 275;
                this.textareaWidth = window.innerWidth - 310;

                // 监听窗口大小变化
                let self = this;
                window.onresize = function() {
                    self.inputWidth = window.innerWidth / 2 - 275;
                    self.textareaWidth = window.innerWidth - 310;
                };
            });
        },
        methods: {
        },
    };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// graduateRequire.vue?562fdbbe